import { IViewSettings } from "./ViewSettings"

export const SHOW_COMPLETED_MAINTENANCES_DEFAULT = false

export interface IViewSettingsMaintenance {
    showCompletedMaintenances?: boolean
}

export default class ViewSettingsMaintenance implements IViewSettings {
    showCompletedMaintenances: boolean = SHOW_COMPLETED_MAINTENANCES_DEFAULT

    constructor(data: IViewSettingsMaintenance) {
        if (typeof data.showCompletedMaintenances !== "undefined") {
            this.showCompletedMaintenances = data.showCompletedMaintenances
        }
    }

    get isDefault() {
        return this.showCompletedMaintenances === SHOW_COMPLETED_MAINTENANCES_DEFAULT
    }
}
